import React from 'react'
import './App.css';

const PrivacyScreen = () => {
  return (
    <div className="content-screen">
      <h1>Privacy Policy – ActivoLog – Status Tracker</h1>
      <div className="content">
        <p className="last-updated">Last Updated: 21-10-2025</p>
        <p>Welcome to ActivoLog – Status Tracker ("Application", "App"), operated by ActivoLog ("Company", "We", "Us", "Our"). This Privacy Policy explains how we collect, use, and protect your information when you use our Application. By using the App, you agree to this Privacy Policy.</p>
        
        <h2>1. Important Disclaimer</h2>
        <p>ActivoLog – Status Tracker is designed for entertainment and informational purposes only.</p>
        <p>The App does NOT:</p>
        <ul>
          <li>Access private messages</li>
          <li>Track real-time personal activity of others</li>
          <li>Hack, monitor, or retrieve private data from third-party apps (such as WhatsApp, Instagram, etc.)</li>
        </ul>
        <p>Any results shown in the App are system-generated, simulated, or based on user interaction, and should not be considered real or factual data.</p>
        
        <h2>2. Information We Collect</h2>
        <p>We may collect the following types of data:</p>
        <p>a. Personal Information (Optional)</p>
        <ul>
          <li>Phone number</li>
          <li>(Only if you provide it)</li>
        </ul>
        
        <p>b. Device & Usage Data</p>
        <ul>
          <li>Device model and OS</li>
          <li>App usage behavior</li>
          <li>Crash logs</li>
          <li>IP address (for security)</li>
        </ul>
        
        <p>c. Analytics Data</p>
        <p>We may use analytics tools (such as Firebase Analytics) to understand:</p>
        <ul>
          <li>User behavior</li>
          <li>Feature usage</li>
          <li>App performance</li>
        </ul>
        
        <h2>3. How We Use Your Information</h2>
        <p>We use collected data to:</p>
        <ul>
          <li>Operate and improve the App</li>
          <li>Provide customer support</li>
          <li>Process subscriptions and purchases</li>
          <li>Send important updates</li>
          <li>Detect fraud or misuse</li>
        </ul>
        
        <h2>4. In-App Purchases & Subscriptions</h2>
        <p>ActivoLog offers paid features via subscriptions.</p>
        <ul>
          <li>Payments are handled by Google Play</li>
          <li>Subscriptions may auto-renew unless canceled</li>
          <li>We do not store your payment details</li>
        </ul>
        <p>For billing issues, please contact Google Play directly.</p>
        
        <h2>5. Third-Party Services</h2>
        <p>We may use trusted third-party services such as:</p>
        <ul>
          <li>Firebase Analytics</li>
          <li>Google Play Services</li>
        </ul>
        <p>These services may collect data according to their own privacy policies.</p>
        
        <h2>6. Data Sharing</h2>
        <p>We do NOT sell your personal data.</p>
        <p>We may share data only:</p>
        <ul>
          <li>With service providers (analytics, hosting)</li>
          <li>If required by law</li>
          <li>To protect our legal rights</li>
        </ul>
        
        <h2>7. Data Retention</h2>
        <p>We keep your data only as long as necessary to:</p>
        <ul>
          <li>Provide services</li>
          <li>Meet legal requirements</li>
          <li>Resolve disputes</li>
        </ul>
        <p>After that, data is deleted or anonymized.</p>
        
        <h2>8. Data Security</h2>
        <p>We take reasonable steps to protect your data. However, no system is 100% secure.</p>
        
        <h2>9. Your Rights</h2>
        <p>You can request:</p>
        <ul>
          <li>Access to your data</li>
          <li>Correction of data</li>
          <li>Deletion of data</li>
        </ul>
        <p>Contact us for any requests.</p>
        
        <h2>10. Children's Privacy</h2>
        <p>This App is not intended for users under 18 years of age. We do not knowingly collect data from children.</p>
        
        <h2>11. Changes to This Policy</h2>
        <p>We may update this Privacy Policy at any time. Changes will be posted in the App.</p>
        
        <h2>12. Contact Us</h2>
        <p>If you have any questions:</p>
        <p>📧 Email: info.gemmure@gmail.com</p>
      </div>
    </div>
  )
}

export default PrivacyScreen

